/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Format_LabelInputs */

const en_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Format`)
};

const fr_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format audio`)
};

const de_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioformat`)
};

const it_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato audio`)
};

const ru_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоформат`)
};

const es_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de audio`)
};

const zh_cn2_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频格式`)
};

const ja_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオフォーマット`)
};

const hi_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो प्रारूप`)
};

const pt_pt2_audio_description_export_audio_format_label = /** @type {(inputs: Audio_Description_Export_Audio_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Format" |
*
* @param {Audio_Description_Export_Audio_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_format_label = /** @type {((inputs?: Audio_Description_Export_Audio_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_audio_format_label(inputs)
	if (locale === "de") return de_audio_description_export_audio_format_label(inputs)
	if (locale === "it") return it_audio_description_export_audio_format_label(inputs)
	if (locale === "ru") return ru_audio_description_export_audio_format_label(inputs)
	if (locale === "es") return es_audio_description_export_audio_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_audio_format_label(inputs)
	if (locale === "ja") return ja_audio_description_export_audio_format_label(inputs)
	if (locale === "hi") return hi_audio_description_export_audio_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_audio_format_label(inputs)
	return en_audio_description_export_audio_format_label(inputs)
});